<template>
  <div>
    <v-card outlined>
      <v-card-title class="title">
        {{ $tt('customPay') }}
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
            <th>{{ $tt('customBillingContractPeriod') }}</th>
            <th>{{ $tt('customPay') }}</th>
            <th>{{ $tt('customBillingAmount') }}</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="purchase in purchaseInfo.getPurchases()" :key="purchase.orderId">
              <template>
                <td v-if="purchase.autoRenewing">
                  {{ purchase.startedAt | aidToYearMonthDay }}
                  -
                  {{ purchase.expiredAt | aidToYearMonthDay }}
                </td>
                <td v-else>{{ $tt('customBillingCancellation') }}: {{ purchase.expiredAt | aidToYearMonthDay }}</td>
                <td>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-img
                        :src="getBillingVendorIconUrl(purchase)"
                        class="ma-0 elevation-1"
                        max-width="24"
                        v-on="on"
                      />
                    </template>
                    <span>{{ getPlanNameFromPurchase(purchase) }}</span>
                  </v-tooltip>
                </td>
                <td>
                  {{ getPurchaseAmountText(purchase) }}
                  <v-tooltip right v-if="isShowStripeInvoice(purchase)">
                    <template v-slot:activator="{ on }">
                      <v-btn icon color="grey darken-3" :href="purchase.invoiceUrl" target="_blank" v-on="on">
                        <v-icon>receipt</v-icon>
                      </v-btn>
                    </template>
                    {{ $tt('customBillingReceipt') }}
                  </v-tooltip>
                </td>
              </template>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PurchaseInfo from '@/lib/purchase-info'
import storage from '@/lib/storage'
import * as Filter from '@/lib/filters'
import BillingMixin from '@/components/mixins/billing-mixin'
export default {
  name: 'PaymentInformationComponent',
  mixins: [BillingMixin],
  data() {
    return {
      purchaseInfo: storage.getPurchaseInfo(),
    }
  },
  mounted() {
    this.$store.dispatch('getPurchaseInfo')
  },
  methods: {
    getPlanNameFromPurchase(purchase) {
      if (this.isVendorGoogle(purchase)) {
        return 'Google Play'
      }
      const planId = purchase.planId
      for (let i = 0; i < this.billingPlans.length; i++) {
        const billingPlan = this.billingPlans[i]
        if (billingPlan.id === planId) {
          // API の displayName (AgriBus Professional 等) を表示。plan は識別子
          return billingPlan.displayName || billingPlan.plan
        }
      }
      return null
    },
    getPurchaseAmountText(purchase) {
      let amount = 0
      if (this.isVendorGoogle(purchase)) {
        if (purchase.autoRenewing) {
          amount = purchase.amountPaid
        }
      }
      if (this.isVendorStripe(purchase)) {
        if (this.isShowStripeInvoice(purchase)) {
          amount = purchase.amountPaid
        }
      }
      if (amount > 0) {
        return Filter.aidFormatPrice(amount, purchase.currency)
      }
      return '---'
    },
    getBillingVendorIconUrl(purchase) {
      const vendor = purchase.billingVendor
      if (vendor === PurchaseInfo.VENDOR_STRIPE) {
        return '/images/aid-32.png'
      }
      if (vendor === PurchaseInfo.VENDOR_GOOGLE) {
        return '/images/google-play-32.png'
      }
      return null
    },
    isVendorGoogle(purchase) {
      const vendor = purchase.billingVendor
      return vendor === PurchaseInfo.VENDOR_GOOGLE
    },
    isVendorStripe(purchase) {
      const vendor = purchase.billingVendor
      return vendor === PurchaseInfo.VENDOR_STRIPE
    },
    isShowStripeInvoice(purchase) {
      if (this.isVendorStripe(purchase) && purchase.state === PurchaseInfo.STATE_PAID) {
        return true
      }
      return false
    },
  },
}
</script>
